import React from "react";
import PropTypes from "prop-types";
import _snakeCase from "lodash/snakeCase";
import { Col } from "antd";
import { PermissionContextConsumer } from "hocs";
import CaseDocumentChecklist from "./case-document-checklist";

// const TabPane = Tabs.TabPane;

let caseDetailsTabsArray = [
    {
        tabName: "Case Checklist",
        content: CaseDocumentChecklist,
        permission: "page_dbt_edit"
    },
];

class PaymentProgramDetailsTabs extends React.Component {
    getContentProps = tabName => {
        const {
            caseId,
            companyId,
            isUserAllowedToEdit,
        } = this.props;

        switch (tabName) {
        case "Case Checklist":
            return {
                caseId,
                companyId,
                openAsTab: true
            };
        default:
            return {
                isUserAllowedToEdit
            };
        }
    };
    onTabChange = tabName => {
        const { pageID, caseId } = this.props.match.params;
        this.props.history.replace(
            `/app/${pageID}/${caseId}/${_snakeCase(tabName)}`,
            {
                ...this.props.location.state,
                tabId: _snakeCase(tabName)
            }
        );
    };
    getActiveTab(tab, context) {
        let isTabExisted = caseDetailsTabsArray.find(_ => (context.get(_.permission) || !_.permission) && _snakeCase(_.tabName)  === tab);
        if(isTabExisted) {
            return isTabExisted.tabName;
        }
        return (caseDetailsTabsArray.filter(_ => context.get(_.permission))[0] || {}).tabName;
    }
    render() {
        return (
            <PermissionContextConsumer>
                {context => {
                    const activeTab = caseDetailsTabsArray.find(_ => (_.tabName === "Case Checklist"));
                    return (
                        <React.Fragment>   
                            <Col span={24} className={"mt-10"}>
                                <activeTab.content
                                    {...this.getContentProps(activeTab.tabName)}
                                    permissionContext={context}
                                    caseId={this.props.caseId}
                                />     
                            </Col> 
                        </React.Fragment>
                    );
                }}
            </PermissionContextConsumer>
        );
    }
}

PaymentProgramDetailsTabs.propTypes = {
    closeDrawer: PropTypes.func,
    caseDetail: PropTypes.object,
    supplyChainDetail: PropTypes.object,
    caseSanction: PropTypes.any,
    toggleExpand: PropTypes.func,
    companyId: PropTypes.number,
    isAnchor: PropTypes.bool,
    caseId: PropTypes.number,
    tab: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    stageId: PropTypes.number,
    stageName: PropTypes.string,
    caseTaskId: PropTypes.number,
    openDocView: PropTypes.func,
    getActionModal: PropTypes.func,
    viewCaseNotes: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    companyName: PropTypes.string,
    isUserAllowedToEdit: PropTypes.bool,
    isDisbursedStage: PropTypes.bool
};

export default PaymentProgramDetailsTabs;